import styled from '@emotion/styled';

import { tableFormatDateNG } from '../../../utils/utils';

interface TableDateFormatterProps {
  data?: Record<string, any>;
  dataKey?: string;
  className?: string;
}

const TableDateFormatter: React.FC<TableDateFormatterProps> = ({
  data,
  dataKey,
  className,
}) => {
  const label = data && data[dataKey ?? ''];
  return (
    <Container className={className}>
      {label ? tableFormatDateNG(String(label ?? '')) : '--'}
    </Container>
  );
};

export default TableDateFormatter;

const Container = styled.div`
  word-break: break-word;
  width: 100%;
`;
